<template>
  <div class="pay-fin-box">
    <user-header></user-header>
    <user-menu :status='0'></user-menu>
    <div class="pay-fin-main-box">
      <div class="fin">
        <h1>ご注文が確定されました。</h1>
        <h2>ご利用、誠にありがとうございました。<br />ご注文いただいた内容については、<br />お送りした確認メール、または<br /><a @click="history">購入履歴</a>ページにてご確認いただけます。</h2>
        <h3>注文番号：{{order_id}}</h3>
      </div>

      <div class="new-add">
        <a @click="new_add">新たにブレンド茶を購入する</a>
        <a @click="history">購入履歴を確認する</a>
      </div>
    </div>
  </div>
</template>

<script>
import UserHeader from '@/views/components/user/UserHeader';
import UserMenu from '@/views/components/user/UserMenu';
export default {
  name: 'PayFin',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
    UserHeader,
    UserMenu,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      order_id: this.$route.query.order_id,
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    new_add () {
      this.$router.push({name: 'uMain', params: {}});
    },
    history () {
      this.$router.push({name: 'uHistory', params: {}});
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.pay-fin-box {
  .pay-fin-main-box {
    padding: 20px;
    margin: 50px 0 0 224px;
    height: calc(100vh - 90px);
  }
  .fin {
    position: relative;
    width: 400px;
    margin: 210px auto 10px auto;
    background: #fefefe;
    border: 8px solid #dddddd;
    padding: 38px 75px 42px 75px;
    h1 {
      color: #1b2010;
      font-size: 28px;
      letter-spacing: 2px;
    }
    h2 {
      font-size: 16px;
      font-weight: 100;
      color: #5b5845;
      margin: 34px 0 37px 0;
      a {
        color: #da7d78;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  .fin:after {
    position: absolute;
    bottom: -40px;
    right: -46px;
    display: block;
    width: 88px;
    height: 112px;
    background-image: url('../../assets/flower.svg');
    content: '';
  }

  .new-add {
    a {
      margin-top: 38px;
      color: #da7d78;
      display: block;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  @media (max-width: 767px) {
    .pay-fin-main-box {
      padding: 20px;
      margin: 0px 0 0 0;
      height: calc(100vh - 90px);

      .fin {
        width: calc(100vw - 110px);
        padding: 18px 15px 22px 15px;
      }
    }
  }
}
</style>
